module.exports = __webpack_public_path__ + "img/final-puzzle.96c5b511.png";